<template>
	<span
		:class="['btn-trigger', expanded && 'is-open']"
		tabindex="0"
		v-on="$listeners"
	>
		<i class="icon icon-arrow_down_filled"></i>
	</span>
</template>

<script>
export default {
	name: 'BtnTrigger',
	props: {
		expanded: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.btn-trigger {
	position: relative;
	font-size: 11px;
	display: flex;
	align-items: center;
	align-self: stretch;
	padding-left: $padding-sm;
	padding-right: $padding-sm;
	border-radius: $border-radius;
	border-bottom-left-radius: 0px;
	border-top-left-radius: 0px;

	.icon {
		line-height: 10px;
		height: 9px;
		@include animation(all, 'slow', ease);
		z-index: $z-level1-3;
	}

	&:hover,
	&:focus,
	&:active,
	&:focus-visible {
		outline: none;

		&::after {
			border-bottom-left-radius: 0px !important;
			border-top-left-radius: 0px !important;
		}
	}

	&.is-open {
		.icon {
			transform: translateY(-1px) scaleY(-1);
			@include animation(all, 'slow', ease);
		}
	}
}
</style>
